import React from "react";

const Developer = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#6b8e23]">
            About Godrej Properties
          </h2>
          <div className="w-24 h-1 bg-[#6b8e23] mx-auto mt-3 rounded"></div>
        </div>

        <p className="text-gray-700 leading-relaxed">
          Godrej Properties Limited (GPL) is the real estate arm of the
          127 year old Godrej Group, one of India's most trusted and diversified
          conglomerates. Established in 1990 and headquartered in Mumbai, the
          company has successfully translated its parent group's philosophy of
          innovation, sustainability and excellence into the real estate
          industry, becoming the first Indian real estate developer to receive
          an ISO certification. GPL is currently one of India's largest and only
          truly pan-India developer, with landmark residential, commercial and
          township projects in over 15 major cities including Mumbai,
          Delhi-NCR, Bengaluru, Pune and Hyderabad etc. The company has received
          over 400 awards for its commitment to cutting edge design, green
          building practices and quality construction and achieved record
          pre-sales of over ₹29,444 crore in the financial year 2025,
          solidifying its market leadership.
        </p>
      </div>
    </section>
  );
};

export default Developer;
